import { ExchangeProtectionDetailsPanelWebComponent } from '../../exchangeProtectionDetailsPanel';
import { convertIntToItemType, QuarantineItemTypes } from '../../exchangeProtection/types/itemTypes';
import { convertIntToThreatsStatus } from '../../exchangeProtection/types/statusCodes';
import { convertIntToPointType } from '../../exchangeProtection/types/pointType';
import moment from 'moment';

export class DetailsPanelBuilder {
  static buildExchangeProtectionDetailsPanel(details, translateFn) {
    const panel = new ExchangeProtectionDetailsPanelWebComponent();

    panel.panelConfig = {
      details: translateFn('Details'),
      detectionDetails: {
        title: translateFn('Detection'),
        quarantinedObject: {
          label: translateFn('Quarantined object'),
          value: concatenateItemType(details?.item?.type, details?.item?.name) || '',
        },
        quarantinedOn: {
          label: translateFn('Quarantined on'),
          value: moment(details?.quarantinedDate).format('DD MMM YYYY, HH:mm'),
        },
        status: {
          label: translateFn('Status'),
          value: convertIntToThreatsStatus(details?.threats?.status),
        },
        attachmentName: {
          label: translateFn('Attachment name'),
          value: details?.item?.name,
        },
        threatName: {
          label: translateFn('Threat name'),
          value: details?.threats?.name,
        },
        detectionPoint: {
          label: translateFn('Detection point'),
          value: `(${convertIntToPointType(details?.detection?.pointType)}) ${details?.detection?.pointPath}`,
        },
        ruleMatched: {
          label: translateFn('Rule matched'),
          value: details?.detection?.rule,
        },
        server: {
          label: translateFn('Server'),
          value: details?.source?.protectedEntity?.name,
        },
      },
      message: {
        title: translateFn('Message'),
        senderIP: {
          label: translateFn('Sender IP'),
          value: details?.email?.senderIp,
        },
        senderEmail: {
          label: translateFn('Sender email'),
          value: details?.email?.senderEmail,
        },
        recipients: {
          label: translateFn('Recipients'),
          value: details?.email?.recipients,
        },
        realRecipients: {
          label: translateFn('Real recipients'),
          value: details?.email?.realRecipients,
        },
        subject: {
          label: translateFn('Subject'),
          value: details?.email?.subject,
        },
      },
      close: translateFn('Close'),
    };
    return panel;
  }
}

function concatenateItemType(itemType: number, itemName: string) {
  return itemType === QuarantineItemTypes.ITEM_TYPE_ATTACHMENT
    ? `(${convertIntToItemType(itemType)}) ${itemName}`
    : convertIntToItemType(itemType);
}
